import jwtDecode from 'jwt-decode';
import { getAccessToken, getEncodedUserCredentials } from './hooks/sessionTokens';

export const OAUTH_ERROR_MESSAGES = {
  popup_closed_by_user: 'Please complete the Google sign in flow. If you were not prompted to choose a Google account, please make sure to disable your popup blocker.',
  access_denied: 'Rackspace requires access to your Google Cloud Platform resources. If you are unable to grant Rackspace access, please contact support for help setting up your Managed Services for Google Cloud Platform account.',
};
export const OAUTH_DEFAULT_ERROR_MESSAGE = 'Unable to connect to your Google account.';

/**
 * Returns whether the current user is signed in
 *
 * @return {Boolean}
 */
export const isSignedIn = () => {
  const userCredentials = getEncodedUserCredentials();
  const userAccessToken = getAccessToken();

  if (!userCredentials || !userAccessToken) {
    return false;
  }
  const credentials = jwtDecode(JSON.stringify(userCredentials));

  return typeof credentials.email === 'string'
    && typeof credentials.name === 'string'
    && typeof userAccessToken === 'string';
};

/**
 * Return GoogleUser profile data
 *
 * @return {{email: String}} - Profile
 * @return {null} if user is not signed in
 */
export const getCurrentUser = () => {
  if (!isSignedIn()) {
    return null;
  }

  const userCredentials = getEncodedUserCredentials();

  const credentials = jwtDecode(JSON.stringify(userCredentials));
  return { email: credentials.email };
};

/**
 * Get authenticated user oauth tokens for id and access
 *
 * @return {{idToken: String, accessToken: String}} - Auth tokens
 * @return {null} if user is not signed in
 */
export const getGoogleCredentials = () => {
  if (!isSignedIn()) {
    return null;
  }

  const accessToken = getAccessToken();
  const idToken = getEncodedUserCredentials();

  return {
    accessToken,
    idToken,
  };
};
